<template>
    <section id="contact-wrapper" class="generic-wrapper">
        <h1 class="page-title">Donde nos puedes encontrar!</h1>
        <div id="map">
            <iframe frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://maps.google.com/maps?ie=UTF8&amp;q=Las+Hamacas&amp;fb=1&amp;hq=hotel+las+hamacas+la+ceiba&amp;cid=0,0,7082023585290643219&amp;hnear=&amp;t=m&amp;source=embed&amp;ll=15.770448,-86.757917&amp;spn=0.006195,0.006437&amp;z=16&amp;iwloc=A&amp;output=embed"></iframe>
        </div>

        <h2 class="page-subtitle">Mas de una manera de contactarnos</h2>
        <div id="contact-info-wrapper">

            <ul id="phone-numbers" class="list">
                <li>+504 2440-5298</li>
                <li>+504 9699-0886</li>
                <li>+504 3197-7595</li>
            </ul>

            <ul id="emails" class="list">
                <li><a href="mailto:info@hotellashamacas.com">info@hotellashamacas.com</a></li>
                <li><a href="mailto:reservaciones@hotellashamacas.com">reservaciones@hotellashamacas.com</a></li>
            </ul>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Contact'
}
</script>

<style scoped>
    #contact-wrapper {
        padding-left: 0;
        padding-right: 0;
    }
    #map {
        width: 100%;
        height: 450px;
    }

    #map iframe {
        width: 100%;
        height: 100%;
    }

    #contact-info-wrapper {
        display: flex;
        justify-content: space-evenly;
    }

    #contact-info-wrapper ul {
        padding: 0;
        margin: 0;
        list-style-type: none;
        display: flex;
        flex-direction: column;
    }

    #contact-info-wrapper .list {
        font-size: 20px;
        font-weight: 400;
    }

    #contact-info-wrapper .list li {
        padding: 7px 0;
        text-align: center;
        border-bottom: 1px solid #e46658;
    }

    #contact-info-wrapper .list li a {
        text-decoration: none;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {

        #contact-info-wrapper {
            flex-direction: column;
        }

        #contact-info-wrapper .list {
            font-size: 18px;
        }
    }
</style>
